import Auth from '../Components/User/Auth';
const LoginPage = () => {
    return (
        <>
            <header className="App-header">
                <Auth></Auth>
            </header>
        </>
    );
}

export default LoginPage